import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBDropDown, CancelButton, StatusWarning } from '_components';
import styles from './Common.module.css'

class OtherUntimedEntry extends React.Component {

    removeEntry() {
        this.props.removeChildRow(this.props.noteId, 'PTPLANUNTIMEDOTHER', 'UO', this.props.entry.UONO);
    }

    render() {
        return (
            <div className={styles.entry_wrapper}>
                <div className={styles.row}>
                    <DBDropDown
                        noteId={this.props.noteId}
                        entity='PTPLANUNTIMEDOTHER'
                        entityKeyColumn='UONO'
                        entityKeyValue={this.props.entry.UONO}
                        field='UOOENO'
                        disabled={this.props.disabled}
                        className={styles.entry_dropdown}
                        customOptions={this.props.options}
                    />
                    {!this.props.disabled &&
                        <div className={styles.remove_button}>
                            <CancelButton title='Remove' size='extra-small' onClick={() => this.removeEntry()} />
                        </div>
                    }
                    {this.props.disabled &&
                        <div className={styles.disabled_flag}>
                            <StatusWarning size='extra-small' title='This code is required in the plan based on the Activity Log' />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let options = state.entities.masterData.MLMASTEROTHER ?
        Object.keys(state.entities.masterData.MLMASTEROTHER)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTEROTHER[key].OEPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTEROTHER[key].OEMC) ||
                    (isWc && state.entities.masterData.MLMASTEROTHER[key].OEWC) ||
                    (isAuto && state.entities.masterData.MLMASTEROTHER[key].OEAUTO) ||
                    (isOther && state.entities.masterData.MLMASTEROTHER[key].OEOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTEROTHER[a].OENAME.localeCompare(state.entities.masterData.MLMASTEROTHER[b].OENAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTEROTHER[key].OENO,
                    value: state.entities.masterData.MLMASTEROTHER[key].OENAME + ' - ' + state.entities.masterData.MLMASTEROTHER[key].OECODE
                }
            )) : [];

    let disabled = state.entities.notes.MLOTHER &&
        Object.keys(state.entities.notes.MLOTHER)
            .find(key => (state.entities.notes.MLOTHER[key].XLOEXLNO === xlno &&
                state.entities.notes.MLOTHER[key].XLOEPERFORMED === true &&
                state.entities.notes.MLOTHER[key].XLOEOENO === state.entities.notes.PTPLANUNTIMEDOTHER[ownprops.id].UOOENO)) !== undefined ? true : false;

    return {
        noteId,
        entry: state.entities.notes.PTPLANUNTIMEDOTHER[ownprops.id],
        options,
        disabled
    };
}

const connectedOtherUntimedEntry = connect(mapStateToProps, mapDispatchToProps)(OtherUntimedEntry);
export { connectedOtherUntimedEntry as OtherUntimedEntry };


